export const selectCustomers = (state) => state.customers;

export const selectCustomersList = (state) => state.customers.list;
export const selectCustomersListLoading = (state) => state.customers.loading;
export const selectCustomersListPag = (state) => state.customers.listPag;
export const selectCustomersListLoadingPag = (state) => state.customers.loadingPag;
export const selectCustomersListLoadingCount = (state) => state.customers.loadingCount;
export const selectCustomersListError = (state) => state.customers.error;
export const selectCustomerFilters = (state) => state.customers.filters;